<template>
  <div class="reward-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="stage">
          <img class="star-fx" :src="imgStarFx" alt="" />
          <div class="card">
            <div class="header">
              <div class="title">请选择您想要的权益（六选一）</div>
            </div>
            <div class="options" @touchmove.stop>
              <div
                v-for="item in options"
                :key="item.rightsCode"
                class="option"
                :class="{
                  active: selectedIndex === item.rightsCode,
                  disabled: !item.totalQuantity,
                  multiline: isMultiline(item.rightsName)
                }"
                @click="item.totalQuantity && selectOption(item)"
              >
                <div class="left">
                  <div class="name">{{ item.rightsName }}</div>
                  <div class="stock">剩余{{ item.totalQuantity }}份</div>
                </div>
                <img
                  v-if="!item.totalQuantity"
                  class="sold-out"
                  :src="imgSoldOut"
                  alt="已领完"
                />
                <img
                  v-if="item.type === 5"
                  class="exclusive-tag"
                  :src="imgExclusiveTag"
                  alt="鹭愿卡专享"
                />
                <img
                  v-show="item.totalQuantity && selectedIndex === item.rightsCode"
                  class="check"
                  :src="imgCheck"
                  alt=""
                />
              </div>
            </div>
            <div class="btns">
              <img class="btns-img" :src="imgConfirmBtns" alt="" />
              <button
                class="btn-hit"
                type="button"
                aria-label="确认"
                @click.stop="onConfirm"
              />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  luyuanNewCustomerReceive,
  luyuanNewCustomerQueryConfig
} from '@/api/luyuan'
import { generateLink2 } from '@/api/communal'

/** 接口未就绪：按设计稿写死六选一奖品，覆盖正常/已领完/选中/专享标签等样式 */
const MOCK_OPTIONS = [
  {
    rightsCode: 'mock_wx',
    rightsName: '38元微信立减金',
    totalQuantity: 999,
    type: 1
  },
  {
    rightsCode: 'mock_jd',
    rightsName: '38元京东e卡',
    totalQuantity: 0,
    type: 2
  },
  {
    rightsCode: 'mock_jf',
    rightsName: '2400积分商城积分',
    totalQuantity: 999,
    type: 3
  },
  {
    rightsCode: 'mock_rice',
    rightsName: '中粮福临门唯粹\n东北长粒香米1kg',
    totalQuantity: 1000,
    type: 4
  },
  {
    rightsCode: 'mock_yg',
    rightsName: '舒客红花清火惠享组合\n4支装ZHS-HH40',
    totalQuantity: 1000,
    type: 4
  },
  {
    rightsCode: 'mock_bl',
    rightsName: '640厦门航空白鹭积分',
    totalQuantity: 888,
    type: 5
  }
]

export default {
  name: 'RewardModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userRightsToken: {
      type: String,
      default: ''
    },
    userRightsLevel: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      selectedIndex: undefined,
      options: [],
      imgStarFx: require('@/assets/imgs/xibNewCustomerGift/luyuanRewardStarFx.png'),
      imgSoldOut: require('@/assets/imgs/xibNewCustomerGift/luyuanRewardSoldOut.png'),
      imgCheck: require('@/assets/imgs/xibNewCustomerGift/luyuanRewardCheckNew.png'),
      imgExclusiveTag: require('@/assets/imgs/xibNewCustomerGift/luyuanRewardExclusiveTag.png'),
      imgConfirmBtns: require('@/assets/imgs/xibNewCustomerGift/luyuanRewardConfirmBtns.png')
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.loadOptions()
        }
      },
      immediate: true
    }
  },
  methods: {
    isMultiline(name) {
      return typeof name === 'string' && name.includes('\n')
    },
    async loadOptions() {
      // TODO: 接口就绪后恢复 luyuanNewCustomerQueryConfig
      const { data } = await luyuanNewCustomerQueryConfig()
      this.options = data || []
      // this.options = MOCK_OPTIONS.map(item => ({ ...item }))
      // 默认选中设计稿中的实物选中态，便于一眼看到勾选样式
      const selectedDemo = this.options.find(item => item.rightsCode === 'mock_rice')
      const firstSelectable = this.options.find(item => item.totalQuantity !== 0)
      this.selectedIndex = (selectedDemo || firstSelectable)?.rightsCode
    },
    selectOption(item) {
      this.selectedIndex = item.rightsCode
    },
    async onConfirm() {
      // 商品类型，1-微信立减金，2-券仓商品，3-积分商品，4-实物商品，5-白鹭积分
      const selectedEquityCode = this.selectedIndex
      if (!selectedEquityCode) {
        this.$toast('请选择一个权益')
        return
      }
      const selectedEquity = this.options.find(
        item => item.rightsCode === selectedEquityCode
      )
      if (!selectedEquity || !selectedEquity.totalQuantity) {
        this.$toast('该权益已领完')
        return
      }
      // mock 数据阶段：仅关闭并提示，避免无效领取请求
      if (String(selectedEquityCode).startsWith('mock_')) {
        this.$toast('奖品接口未就绪，当前为设计稿预览')
        this.$emit('confirm')
        return
      }
      if (selectedEquity.type === 1) {
        this.$emit('confirm')
        this.jumpWxDetail(selectedEquityCode)
        return
      }
      if ([4].includes(selectedEquity.type)) {
        this.$emit('confirm')
        this.$router.push({
          path: '/luyuanNewCustomerGiftAddressForm',
          query: {
            rightsCode: selectedEquityCode,
            userRightsToken: this.userRightsToken
          }
        })
        return
      }
      const { data } = await luyuanNewCustomerReceive({
        userRightsToken: this.userRightsToken,
        rightsCode: selectedEquityCode
      })
      this.$emit('confirm')
      if (data.sendRes === 1) {
        this.$router.push({
          path: '/luyuanNewCustomerGiftDetail',
          query: { id: data?.id }
        })
      } else {
        this.$router.push({ path: '/luyuanPromotionGiftFailDetail' })
      }
    },
    async jumpWxDetail(rightsCode) {
      const urlToken = sessionStorage.getItem('luyuanToken')
      const url = `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/luyuanNewCustomerGiftWxDetail?urlToken=${urlToken}&userRightsToken=${this.userRightsToken}&rightsCode=${rightsCode}`
      const { data } = await generateLink2({
        link: encodeURIComponent(url)
      })
      window.location.href = data.urlLink
    }
  }
}
</script>

<style lang="less" scoped>
/* 设计稿 750 ÷ 2 */
.reward-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 8px 0;
  }

  .stage {
    position: relative;
    width: 376px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .star-fx {
    position: absolute;
    left: 0;
    top: -16px;
    width: 100vw;
    object-fit: contain;
    object-position: center top;
    pointer-events: none;
    z-index: 0;
  }

  .card {
    position: relative;
    z-index: 1;
    width: 317.5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    filter: drop-shadow(0 0 10px rgba(188, 244, 246, 0.95));
  }

  .header {
    width: 297px;
    height: 70.5px;
    background: url('~@/assets/imgs/xibNewCustomerGift/luyuanModalTitleBg.png')
      no-repeat center top;
    background-size: 297px 70.5px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    z-index: 2;
    flex-shrink: 0;
  }

  .title {
    font-size: 14px;
    color: #1b899f;
    line-height: 14px;
    text-align: center;
    padding-bottom: 8px;
    white-space: nowrap;
  }

  .options {
    width: 297px;
    margin-top: -1px;
    padding: 12px 24px 120px;
    box-sizing: border-box;
    background: #e8fdff;
    /* 优先铺开 6 项；小屏再滚动 */
    max-height: min(560px, calc(100dvh - 210px));
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    z-index: 1;
  }

  .option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 249px;
    min-height: 50px;
    margin: 0 auto 10px;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #1C869B;
    border-radius: 10px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    &.multiline {
      min-height: 66.5px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    &.active {
      border-width: 1px;
      border-color: #1b899f;

      .name {
        color: #1c859a;
      }
    }

    &.disabled {
      background: rgba(255, 255, 255, 0.5);
      border-color: rgba(51, 51, 151, 0.5);
      cursor: not-allowed;

      .name,
      .stock {
        color: #999;
      }
    }

    .left {
      width: 152px;
      flex: none;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .name {
      font-size: 14px;
      line-height: 14px;
      color: #000;
      white-space: pre-line;
      word-break: break-all;
      line-height: 1.3;
    }

    .stock {
      font-size: 10px;
      line-height: 10px;
      color: #000;
    }

    .check {
      width: 19px;
      height: 15px;
      margin-left: 8px;
      flex-shrink: 0;
      object-fit: contain;
    }

    .sold-out {
      width: 48.5px;
      height: 37.5px;
      margin-left: 8px;
      flex-shrink: 0;
      object-fit: contain;
    }

    .exclusive-tag {
      position: absolute;
      top: 0;
      right: 0;
      width: 63.5px;
      height: 18.5px;
      object-fit: contain;
    }
  }

  .btns {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 317.5px;
    height: 124px;
    z-index: 3;
  }

  .btns-img {
    display: block;
    width: 317.5px;
    height: 124px;
  }

  .btn-hit {
    position: absolute;
    left: 50%;
    top: 33px;
    transform: translateX(-50%);
    width: 170px;
    height: 42px;
    padding: 0;
    border: 0;
    background: transparent;
    outline: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
}
</style>
